import parse from "html-react-parser";

export const parseContent = (content: string) => {
	return content ? parse(content) : "";
};
export const stripHtml = (content = "") => {
	return content.replace(/(<([^>]+)>)/gi, "");
};
